module.exports = __webpack_public_path__ + "media/images/icon_comment-a775412a9d13415adb9cd30a7b03e7df.png";